export default __webpack_public_path__ + "static/media/Helm of the Savage Fang.18ecd45d.jpg";